// removed by extract-text-webpack-plugin
module.exports = {"details-container":"_1RmzL0qghsrllPgAd_X9u6","view-header":"_3-zllYRRNxsKtfVg04KWrg","member-info":"_15-lBcERAPz_32eB1CGdk-","spouse-info":"_19PpkLmpVgI0vXho_8CwZK","member-type":"Mu4E8sw7USVu9MDn1869l","action-button":"_2H9SKLfldyOPyU6OynB5Rm","copy-button":"_1ZsR5ex9EoWR5wErkVOYfK","status-color-active":"gqPO5sAJ-yQhWlb2YGPEY","status-color-expire":"amSa0rty2PXp_y7VT18nJ","status-color-cancel":"_1xka2DddgLfh3GpzdS6tE0","status-color-suspend":"qudL8Rt-pFQouN11EX4nX"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ViewMember/styles.css
// module id = 1575
// module chunks = 0